module.exports = __webpack_public_path__ + "static/assets/878034a3b034a26642f246c53d68d502.png";